import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import XLSX from "xlsx";

function updateMonthlyLength(cong) {
  _.forOwn(cong.monthly, function(val, key) {
    while (cong.monthly[key].length > cong.monthCount) {
      cong.monthly[key].pop();
    }
    while (cong.monthly[key].length < cong.monthCount) {
      cong.monthly[key].push(null);
    }
  });
}

const state = {
  test: "a",
  configs: [],
  predictions: [],
  strings: {
    tableHeaders: [
      "Month",
      "Budget",
      "CPS ($)",
      "Sign-Ups",
      "Percentage of Organic Sign-ups (%)",
      "Sign-Ups Organic",
      "Sign-Ups Total",
      "Free trail to subs. rate (%)",
      "New Subs from Sign-Ups",
      "Average Monthly Churn Rate (%)",
      "Monthly Churn (actual)",
      "Subscribers",
    ],
  },
  defaults: {
    name: "Churn",
    trialConversion: 50,
    currency: "USD",
    churn: 10,
    CPS: 15,
    signUpsOrganic: 25,
    budget: 100000,
    monthCount: 10,
    startingSubscribers: 0,
    monthly: {
      budget: [],
      CPS: [],
      churnPercent: [],
      signUpsOrganicPercent: [],
      trialConversionPercent: [],
    },
  },
};
function safePercent(num) {
  if (_.isNaN(num / 100)) {
    return "";
  } else {
    return num / 100;
  }
}
function addExcelSummary(i, months, row, currency) {
  let curSymbol = "$";
  if (currency == "GBP") {
    curSymbol = "£";
  }
  if (currency == "EUR") {
    curSymbol = "€";
  }
  let letters = "ABCDEFGHIJKLMNOPQRSTUBWXYZ";
  let monthLetter = letters[months];
  if (monthLetter == "A" || monthLetter == "B") {
    monthLetter = "";
  }
  switch (i) {
    case 0: {
      row.push({
        v: "Grand Total",
        t: "s",
      });
      break;
    }
    case 1: {
      row.push({
        t: "n",
        z: curSymbol + "#,###",
        f: `SUM(C2:${monthLetter}2)`,
      });
      break;
    }
    case 2: {
      row.push({
        t: "n",
        z: curSymbol + "#,###.##",
        f: `AVERAGE(C3:${monthLetter}3)`,
      });
      break;
    }
    case 3: {
      row.push({
        t: "n",
        z: "#,###",
        f: `SUM(C4:${monthLetter}4)`,
      });
      break;
    }
    case 4: {
      row.push({
        t: "n",
        z: "##.##%",
        f: `AVERAGE(C5:${monthLetter}5)`,
      });
      break;
    }
    case 5: {
      row.push({
        t: "n",
        z: "#,###",
        f: `SUM(C6:${monthLetter}6)`,
      });
      break;
    }
    case 6: {
      row.push({
        t: "n",
        z: "#,###",
        f: `SUM(C7:${monthLetter}7)`,
      });
      break;
    }
    case 7: {
      row.push({
        t: "n",
        z: "##.##%",
        f: `AVERAGE(C8:${monthLetter}8)`,
      });
      break;
    }
    case 8: {
      row.push({
        t: "n",
        z: "#,###",
        f: `SUM(C9:${monthLetter}9)`,
      });
      break;
    }
    case 9: {
      row.push({
        t: "n",
        z: "##.##%",
        f: `AVERAGE(C10:${monthLetter}10)`,
      });
      break;
    }
    case 10: {
      var val = {
        t: "n",
        z: "#,###",
        f: `SUM(C11:${monthLetter}11)`,
      };

      row.push(val);
      break;
    }
    case 11: {
      let val = {
        t: "n",
        z: "#,###",
        f: `${monthLetter}12`,
      };

      row.push(val);
      break;
    }
    default:
      row.push({ i });
  }
}
function addExcelTab(i, month, row, currency) {
  let curSymbol = "$";
  if (currency == "GBP") {
    curSymbol = "£";
  }
  if (currency == "EUR") {
    curSymbol = "€";
  }
  let letters = "ABCDEFGHIJKLMNOPQRSTUBWXYZ";
  let lastMonthLetter = letters[month.nr];
  let monthLetter = letters[month.nr + 1];
  if (monthLetter == "A" || monthLetter == "B") {
    monthLetter = "";
  }
  switch (i) {
    case 0: {
      row.push({ v: month.nr, t: "n" });
      break;
    }
    case 1: {
      row.push({ v: month.budget, t: "n", z: curSymbol + "#,###" });
      break;
    }
    case 2: {
      row.push({ v: month.CPS, t: "n", z: curSymbol + "#,###.##" });
      break;
    }
    case 3: {
      row.push({
        v: monthLetter ? "" : month.signUps,
        t: "n",
        z: "#,###",
        f: monthLetter ? `=${monthLetter}2/${monthLetter}3` : "",
      });
      break;
    }
    case 4: {
      row.push({
        v: safePercent(month.signUpsOrganicPercent),
        t: "n",
        z: "##.##%",
      });
      break;
    }
    case 5: {
      row.push({
        v: monthLetter ? "" : month.signUpsOrganic,
        t: "n",
        z: "#,###",
        f: monthLetter ? `=${monthLetter}4*${monthLetter}5` : "",
      });
      break;
    }
    case 6: {
      row.push({
        v: monthLetter ? "" : month.totalSignups,
        t: "n",
        z: "#,###",
        f: monthLetter ? `=${monthLetter}6+${monthLetter}4` : "",
      });
      break;
    }
    case 7: {
      row.push({
        v: safePercent(month.trialConversionPercent),
        t: "n",
        z: "##.##%",
      });
      break;
    }
    case 8: {
      row.push({
        v: monthLetter ? "" : month.newSubs,
        t: "n",
        z: "#,###",
        f: monthLetter ? `=${monthLetter}7*${monthLetter}8` : "",
      });
      break;
    }
    case 9: {
      row.push({ v: safePercent(month.churnPercent), t: "n", z: "##.##%" });
      break;
    }
    case 10: {
      var val = {
        t: "n",
        z: "#,###",
      };
      if (month.nr && month.nr > 0) {
        val.f = monthLetter ? `=${lastMonthLetter}12*${monthLetter}10` : "";
      } else {
        val.v = month.churn;
      }
      row.push(val);
      break;
    }
    case 11: {
      let val = {
        t: "n",
        z: "#,###",
      };
      if (month.nr && month.nr > 0) {
        val.f = monthLetter
          ? `=${lastMonthLetter}12*(100%-${monthLetter}10)+${monthLetter}9`
          : "";
      } else {
        val.v = month.subscribers;
      }
      row.push(val);
      break;
    }
    default:
      row.push({ i });
  }
}
const actions = {
  createExcel({ state }) {
    const wb = XLSX.utils.book_new();
    let currency = state.configs[0].currency;
    state.predictions.forEach(function(prediction, predInd) {
      let tab = [];
      state.strings.tableHeaders.forEach(function(name, i) {
        // add Row
        let row = [{ v: name, t: "s" }];
        for (let index = 0; index < prediction.months.length; index++) {
          let month = prediction.months[index];
          addExcelTab(i, month, row, currency);
          prediction.months[index];
        }

        addExcelSummary(i, prediction.months.length, row, currency);
        /*if (i == 0) {
          row[prediction.months.length + 1] = {
            v: "Grand Total",
            t: "s",
          };
          let sumColumnNr = prediction.months.length + 1;
          // add formulas for all summary
          row[sumColumnNr]
        }*/
        tab.push(row);
      });
      const ws = XLSX.utils.aoa_to_sheet(tab);
      ws["!cols"] = [{ wch: 30 }];
      for (let index = 0; index < prediction.months.length; index++) {
        ws["!cols"].push({ wch: 10 });
      }
      ws["!cols"].push({ wch: 20 });
      XLSX.utils.book_append_sheet(wb, ws, state.configs[predInd].name);
    });
    /* generate file and send to client */
    XLSX.writeFile(wb, "projections.xlsx");
  },
  initialize({ commit, state }) {
    if (state.configs.length == 0) {
      commit("ADD_CONFIG");
      commit("RECALCULATE_PREDICTIONS");
    }
  },
  removeConfig({ commit }, id) {
    commit("REMOVE_CONFIG", id);
    commit("RECALCULATE_PREDICTIONS");
  },
  addConfig({ commit }) {
    commit("ADD_CONFIG");
    commit("RECALCULATE_PREDICTIONS");
  },
  updateConfig({ commit }, config) {
    commit("UPDATE_CONFIG_VALUES", config);
    commit("RECALCULATE_PREDICTIONS");
  },
  updateConfigs({ commit, state }, config) {
    _.forEach(state.configs, function(oldConfig) {
      let id = oldConfig.id;
      config.id = id;
      commit("UPDATE_CONFIG_VALUES", config);
    });
    commit("RECALCULATE_PREDICTIONS");
  },
};
const mutations = {
  ADD_CONFIG: (state) => {
    let cong = {};
    if (state.configs.length == 0) {
      cong = createNewConfig(state.defaults);
      cong.name = "Model ";
    } else {
      cong = createNewConfig(state.configs[state.configs.length - 1]);
      cong.name = "Model " + state.configs.length;
    }
    updateMonthlyLength(cong);

    state.configs.push(cong);
  },
  REMOVE_CONFIG: (state, id) => {
    if (state.configs.length > 0) {
      const i = state.configs.map((item) => item.id).indexOf(id);
      state.configs.splice(i, 1);
    }
  },
  RECALCULATE_PREDICTIONS: (state) => {
    state.predictions = [];
    _.each(state.configs, (config) => {
      state.predictions.push(createPrediction(config));
    });
  },

  UPDATE_CONFIG_VALUES: (state, data) => {
    let { id } = data;
    let config = _.find(state.configs, { id });
    if (data.name) {
      config.name = data.name;
    }
    if (data.currency) {
      config.currency = data.currency;
    }
    if (data.churn) {
      config.churn = data.churn;
    }
    if (data.trialConversion) {
      config.trialConversion = data.trialConversion;
    }
    if (data.CPS) {
      config.CPS = data.CPS;
    }
    if (data.startingSubscribers) {
      config.startingSubscribers = data.startingSubscribers;
    }

    if (data.monthCount) {
      config.monthCount = data.monthCount;
      updateMonthlyLength(config);
    }

    if (data.monthly) {
      _.forOwn(data.monthly, function(val, key) {
        for (let index = 0; index < data.monthly[key].length; index++) {
          // Do not update nulls sent, since we want to have the ability
          // to update only some of this fields
          // TODO: action do reset a value to NULL
          if (data.monthly[key][index] !== null) {
            config.monthly[key][index] = data.monthly[key][index];
          }
        }
      });
    }

    if (data.signUpsOrganic) {
      config.signUpsOrganic = data.signUpsOrganic;
    }
    if (data.budget) {
      config.budget = data.budget;
    }
  },
};

const getters = {
  getFirstConfig: (state) => () => {
    if (state.configs.length > 0) {
      return state.configs[0];
    } else {
      return {};
    }
  },
  getConfigByID: (state) => (id) => {
    return _.find(state.configs, { id });
  },
  getPredictionByID: (state) => (id) => {
    return _.find(state.predictions, { id });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

function createNewConfig(old) {
  let o = {};
  o = {
    ...old,
    id: uuidv4(),
  };

  return o;
}

function calulateNextMonth(config, lastPrediction) {
  let month = {
    nr: lastPrediction.nr + 1,
    signUps: 0,
    CPS: config.CPS,
    signUpsOrganicPercent: 0,
    signUpsOrganic: 0,
    totalSignups: 0,
    newSubs: 0,
    subscribers: 0,
  };

  if (config.monthly.CPS[month.nr - 1]) {
    month.CPS = config.monthly.CPS[month.nr - 1];
  }

  let monthsWithoutSpecifiedBudget = config.monthCount;
  let totalMonthlyBudgetAllocated = 0;
  config.monthly.budget.forEach((val) => {
    if (_.isNumber(val)) {
      monthsWithoutSpecifiedBudget--;
      totalMonthlyBudgetAllocated += val;
    }
  });

  if (config.monthly.budget[month.nr - 1]) {
    month.budget = config.monthly.budget[month.nr - 1];
  } else {
    month.budget = (
      (config.budget - totalMonthlyBudgetAllocated) /
      monthsWithoutSpecifiedBudget
    ).toFixed(0);
  }
  let plannedSignups = month.budget / month.CPS;
  month.monthname = month.nr;

  month.signUps = plannedSignups;

  month.signUpsOrganicPercent = config.signUpsOrganic;
  if (config.monthly.signUpsOrganicPercent[month.nr - 1]) {
    month.signUpsOrganicPercent =
      config.monthly.signUpsOrganicPercent[month.nr - 1];
  }
  month.signUpsOrganic = Math.round(
    plannedSignups * (month.signUpsOrganicPercent / 100)
  );

  month.totalSignups = month.signUps + month.signUpsOrganic;

  month.trialConversionPercent = Number.parseFloat(config.trialConversion);
  if (config.monthly.trialConversionPercent[month.nr - 1]) {
    month.trialConversionPercent =
      config.monthly.trialConversionPercent[month.nr - 1];
  }

  month.newSubs = Math.round(
    ((month.signUps + month.signUpsOrganic) * month.trialConversionPercent) /
      100
  );

  month.churnPercent = Number.parseFloat(config.churn);
  if (config.monthly.churnPercent[month.nr - 1]) {
    month.churnPercent = config.monthly.churnPercent[month.nr - 1];
  }

  month.churn = (lastPrediction.subscribers * month.churnPercent) / 100;
  month.subscribers = Math.round(
    month.newSubs +
      (lastPrediction.subscribers * (100 - month.churnPercent)) / 100
  );
  return month;
}

function createPrediction(config) {
  let prediction = {
    id: config.id,
    months: [],
  };
  let monthCount = config.monthCount;
  let lastMonth = {
    nr: 0,
    signUps: 0,
    signUpsOrganic: 0,
    totalSignups: 0,
    newSubs: 0,
    subscribers: config.startingSubscribers,
  };
  prediction.months.push(lastMonth);
  for (let index = 0; index < monthCount; index++) {
    let month = calulateNextMonth(config, lastMonth);
    prediction.months.push(month);
    lastMonth = month;
  }
  // Calculate prediction totals
  let totals = {
    signUps: 0,
    signUpsOrganic: 0,
    signUpsOrganicPercent: 0,
    totalSignups: 0,
    newSubs: 0,
    subscribers: 0,
    CPS: 0,
    budget: 0,
    trialConversionPercent: 0,
    churnPercent: 0,
    churn: 0,
  };
  prediction.months.forEach((item) => {
    totals.budget += _.isUndefined(item.budget)
      ? 0
      : Number.parseInt(item.budget);
    totals.CPS += _.isUndefined(item.CPS) ? 0 : Number.parseFloat(item.CPS);
    totals.trialConversionPercent += _.isUndefined(item.trialConversionPercent)
      ? 0
      : item.trialConversionPercent;
    totals.signUps += item.signUps;
    totals.churn += _.isUndefined(item.churn)
      ? 0
      : Number.parseFloat(item.churn);
    totals.churnPercent += _.isUndefined(item.churnPercent)
      ? 0
      : item.churnPercent;
    totals.signUpsOrganicPercent += _.isUndefined(item.signUpsOrganicPercent)
      ? 0
      : Number.parseFloat(item.signUpsOrganicPercent);
    totals.signUpsOrganic += item.signUpsOrganic;
    totals.totalSignups += item.totalSignups;
    totals.newSubs += item.newSubs;
    totals.subscribers = item.subscribers;
  });
  // Q: should this be average monhtly or average spent
  let curencyFormat = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: config.currency,
  });
  let valueFormat = Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
  totals.CPS = totals.CPS / monthCount;
  totals.churnPercent = (totals.churnPercent / monthCount).toFixed(2);
  totals.signUpsOrganicPercent = totals.signUpsOrganicPercent / monthCount;
  totals.trialConversionPercent = totals.trialConversionPercent / monthCount;
  let totalsNumbers = _.cloneDeep(totals);
  prediction.totals = totals;
  totals.CPS = curencyFormat.format(totals.CPS);
  totals.trialConversionPercent = totals.trialConversionPercent.toFixed(2);
  totals.signUpsOrganicPercent = totals.signUpsOrganicPercent.toFixed(2);
  totals.churn = valueFormat.format(totals.churn);
  totals.newSubs = valueFormat.format(totals.newSubs);
  totals.totalSignups = valueFormat.format(totals.totalSignups);
  totals.signUpsOrganic = valueFormat.format(totals.signUpsOrganic);
  totals.signUps = valueFormat.format(totals.signUps);
  totals.subscribers = valueFormat.format(totals.subscribers);
  totals.budget = curencyFormat.format(Number.parseFloat(totals.budget));

  prediction.totals = totalsNumbers;
  prediction.totalsStrings = totals;
  return prediction;
}
